import {DependencyInjectId} from '@@/package/const/DependencyInjectId';
import HttpClient from '@@/package/network/HttpClient';
import {type ApplicationContextInterface} from '@@/package/application/applicationContext';
import {type AxiosResponse} from 'axios';
import {
  ProSkillManagerAssessmentModel
} from '~~/package/mapper/proSkillManager/model/assessment/ProSkillManagerAssessmentModel';
import type {PageModel} from '~~/package/mapper/common/model/PageModel';
import {ProSkillManagerType} from '~~/package/mapper/proSkillManager/model/ProSkillManagerType';
import {ProSkillMangerReportModel} from '~~/package/mapper/proSkillManager/model/report/ProSkillManagerReportModel';
import {
  ProSkillManagerSubmissionModel
} from '~~/package/mapper/proSkillManager/model/submission/ProSkillManagerSubmissionModel';
import type {
  ProSkillManagerSummaryModel
} from '~~/package/mapper/proSkillManager/model/summary/ProSkillManagerSummaryModel';
import {
  ProSkillManagerAssessmentDetailInfoModel
} from '~~/package/mapper/proSkillManager/model/assessment/ProSkillManagerAssessmentDetailInfoModel';
import type ProSkillManagerTrackResponse from '~~/package/apis/ProSkillManager/response/ProSkillManagerTrackResponse';
import {
  ProSkillManagerTimelineModel
} from '~~/package/mapper/proSkillManager/model/actions/ProSkillManagerTimelineModel';
import type CustomResponse from '~~/package/types/ResponseType';
import {
  ProSkillManagerAssessmentCandidateSummaryModel
} from '~~/package/mapper/proSkillManager/model/candidate/ProSkillManagerAssessmentCandidateSummaryModel';
import {PageableModel} from '~~/package/mapper/common/model/PageableModel';
import type {
  ProSkillManagerCandidateModel
} from '~~/package/mapper/proSkillManager/model/candidate/ProSkillManagerCandidateModel';

export default class ProSkillManagerApi {

  protected http: HttpClient;

  constructor(context: ApplicationContextInterface) {
    this.http = context.getService<HttpClient>(DependencyInjectId.HttpClient);
  }

  public getProSkillManagerAssessment(lang: string, page: number, itemSize: number, type?: ProSkillManagerType, filters?: string[], title?: string): Promise<AxiosResponse<CustomResponse<PageModel<ProSkillManagerAssessmentModel>>> >{
    return this.http.get<AxiosResponse<CustomResponse<PageModel<ProSkillManagerAssessmentModel>>>>("/pro-skill-manager/assessments", { page, itemSize, type, filters, title }, true, lang);
  }

  public getProSkillManagerAssessmentDetailInfo(id: number): Promise<AxiosResponse<CustomResponse<ProSkillManagerAssessmentDetailInfoModel>>> {
    return this.http.get<AxiosResponse<CustomResponse<ProSkillManagerAssessmentDetailInfoModel>>>(`/pro-skill-manager/assessment/${id}/info`,undefined, true);
  }

  public getProSkillManagerCandidate(lang: string, page: number, size: number, sort?: string, assessmentId?:number, filter?: string, status?: string[]): Promise<AxiosResponse<CustomResponse<PageModel<ProSkillManagerCandidateModel>>>>{
    return this.http.get<AxiosResponse<CustomResponse<PageModel<ProSkillManagerCandidateModel>>>>(`/v2/pro-skill-manager/assessments/candidates`, { page, size, sort, assessmentId, filter, status }, true, lang);
  }

  public getProSkillManagerCandidateSummary(lang: string, assessmentId: number): Promise<AxiosResponse<CustomResponse<ProSkillManagerAssessmentCandidateSummaryModel>> >{
    return this.http.get<AxiosResponse<CustomResponse<ProSkillManagerAssessmentCandidateSummaryModel>>>(`/v2/pro-skill-manager/assessments/${assessmentId}/candidates/summary`, undefined, true, lang);
  }

  public getProSkillManagerTimeline(assessmentId: number, userUUID: string): Promise<AxiosResponse<CustomResponse<ProSkillManagerTimelineModel>>> {
    return this.http.get<AxiosResponse<CustomResponse<ProSkillManagerTimelineModel>>>(`/v2/custom-assessments/${assessmentId}/candidate/${userUUID}/history`, undefined, true);
  }

  public getProSkillManagerReport(lang: string, userUUID: string, assessmentId: number): Promise<AxiosResponse<CustomResponse<ProSkillMangerReportModel>>> {
    return this.http.get<AxiosResponse<CustomResponse<ProSkillMangerReportModel>>>(`/pro-skill-manager/candidates/${userUUID}/assessments/${assessmentId}/reports`, undefined, true, lang, false, false);
  }

  public getProSkillManagerSubmission(lang: string, userUUID: string, assessmentId: number, testTemplateId: number): Promise<AxiosResponse<CustomResponse<ProSkillManagerSubmissionModel>>> {
    return this.http.get<AxiosResponse<CustomResponse<ProSkillManagerSubmissionModel>>>(`/pro-skill-manager/reports/${userUUID}/assessments/${assessmentId}/submissions/${testTemplateId}`, undefined, true, lang, false, false);
  }

  public getProSkillManagerSummary(timeUnit: string, timeAmount: number, type?: ProSkillManagerType, excludeStat?: boolean): Promise<AxiosResponse<CustomResponse<ProSkillManagerSummaryModel>>> {
    return this.http.get<AxiosResponse<CustomResponse<ProSkillManagerSummaryModel>>>("/pro-skill-manager/summary", { timeUnit, timeAmount, type, excludeStat }, true);
  }

  public getProSkillManagerTrack(type?: ProSkillManagerType): Promise<AxiosResponse<CustomResponse<ProSkillManagerTrackResponse>>> {
    return this.http.get<AxiosResponse<CustomResponse<ProSkillManagerTrackResponse>>>("/pro-skill-manager/tracks", { type }, true);
  }

  public getAssessmentTasks(customAssessmentId: number): Promise<AxiosResponse<CustomResponse<Array<{trackTitle: string, trackLevelTitle: string, taskIds: number[]}>>>> {
    return this.http.get<AxiosResponse<CustomResponse<Array<{trackTitle: string, trackLevelTitle: string, taskIds: number[]}>>>>(`/v2/assessments/${customAssessmentId}/tasks`, undefined, true);
  }

  public getPromptHistory(userUUID: string, domain: string, domainId: string | number, taskId: string | number): Promise<AxiosResponse<CustomResponse<{agentInstruction: string | null; items: Array<{ts: number; message: string | null; response: string | null; promptToken: number | null; totalToken: number | null; status: string | null}>}>>> {
    return this.http.get(`/admin/prompt-history`, {userUUID, domain, domainId, taskId}, true);
  }
}
